import {getPacks} from "@api/packs";

export const queryKey = "packs";

export const getPacksQuery = () => ({
  queryKey: [queryKey],
  queryFn: getPacks,
});